export default "/dist/files/icone_securite.f5a06e37ebf5b840d469ecc547371b04.svg";